import { Text } from "@radix-ui/themes";
import { t } from "i18next";
import _, { compact } from "lodash";
import React, { Dispatch, SetStateAction } from "react";
import { Button } from "../../ui/Button";
import { Checkbox } from "../../ui/Checkbox/Checkbox";
import { Input } from "../../ui/Input/Input";
import { Popover, PopoverContent, PopoverTrigger } from "../../ui/Popover";
import { convertRubyToJS } from "../../enums";

type Props = {
  filterState: [string[], Dispatch<SetStateAction<string[]>>];
  content: Array<string>;
  categoryName: string;
  searchbar?: boolean;
  fixed?: boolean;
  convertFromRuby?: boolean;
};

const CategoryPopover = ({
  filterState,
  content,
  categoryName,
  searchbar = true, 
  fixed = false,
  convertFromRuby = false 
}: Props) => {
  const [open, setOpen] = React.useState(false);
  const [filter, setFilter] = filterState;
  const [search, setSearch] = React.useState("");

  const changeFilter = (
    checked: boolean | "indeterminate",
    newFilter: string
  ) => {
    let currentSubFilter: string[];
    if (!checked) {
      currentSubFilter = _.without(filter, newFilter);
    } else {
      currentSubFilter = _.concat(filter, newFilter);
    }
    setFilter(currentSubFilter);
  };

  // Поиск
  const preData = compact(content) // Очистка от "ложных" данных (null, 0, false, '')
  let data = preData.filter((item) =>
    fixed ? t(item).toLowerCase().includes(search.toLowerCase()) : convertFromRuby ? t(convertRubyToJS(item)).toLowerCase().includes(search.toLowerCase()) : item.toLowerCase().includes(search.toLowerCase())
  );

  const handleSearch = (event: any) => {
    setSearch(event.target.value);
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button size={"xs"} variant={"outline"} className="gap-2">
          <span>{categoryName}</span>
          {filter.length > 0 ? <span className="text-xs font-medium">{filter.length}</span> : <></>}
        </Button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-full min-w-[180px] max-w-[400px]">
        {searchbar &&
          <Input
            id="search"
            type="text"
            placeholder={t("search")}
            autoComplete="off"
            className="h-8 mb-2"
            value={search}
            onChange={handleSearch}
          />
        }
        <div className="flex flex-col w-full">
          {data.map((name) => {
            return (
              <Text key={name} as="label" size="3" className="truncate text-sm">
                <div className="flex gap-2 items-center truncate">
                  <Checkbox
                    defaultChecked={filter.includes(name)}
                    onCheckedChange={(e) => {
                      changeFilter(e, name);
                    }}
                  />
                  { fixed ? t(name) : convertFromRuby ? t(convertRubyToJS(name)) : name}
                </div>
              </Text>
            );
          })}
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default CategoryPopover;
